import { GET_BASIC_INFO_FORM, GET_EXTEND_INFO_FORM } from "./types";

export default {
  [GET_BASIC_INFO_FORM]: (state) => state.detail.basic_info,
  [GET_EXTEND_INFO_FORM]: (state) => state.detail.extend_info,
};
